import React from "react";
import "../styles/About.css";
import { motion } from "framer-motion";

function About() {
  return (
    <div className="about-container">
      {/* ✅ Hero Section */}
      <motion.div
        className="about-hero"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <h1 className="about-title">Redefining Brain Health</h1>
        <p className="highlight-text">
          ChronicTrace is leading the future of AI-powered concussion detection. By integrating cutting-edge technology 
          and medical data security, we provide real-time assessments that protect lives and safeguard long-term brain health.
        </p>
      </motion.div>

      {/* ✅ Why ChronicTrace? */}
      <motion.div
        className="about-section"
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1 }}
      >
        <h2 className="section-title">Why ChronicTrace?</h2>
        <p className="section-text">
          Concussions often go undetected, leading to severe long-term consequences. Traditional methods rely on subjective 
          assessments, causing delays in diagnosis and treatment. ChronicTrace uses real-time AI-powered analytics to detect 
          potential concussions, providing immediate support for those in high-risk professions.
        </p>
      </motion.div>

      {/* ✅ Our Mission */}
      <motion.div
        className="about-section"
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1 }}
      >
        <h2 className="section-title">Our Mission</h2>
        <p className="section-text">
          ChronicTrace is dedicated to eliminating uncertainty in concussion management. By integrating biometric tracking, 
          AI-driven risk assessment, and secure medical records, we are building a future where individuals receive 
          immediate, reliable insights to protect their brain health.
        </p>
      </motion.div>

      {/* ✅ Core Values */}
      <motion.div
        className="about-values"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <h2 className="section-title">Core Values</h2>
        <div className="values-grid">
          <div className="value-card">
            <h3>Innovation</h3>
            <p>Pioneering AI and blockchain to improve concussion detection.</p>
          </div>
          <div className="value-card">
            <h3>Precision</h3>
            <p>Delivering real-time, data-driven concussion insights.</p>
          </div>
          <div className="value-card">
            <h3>Security</h3>
            <p>Protecting medical data with encrypted technology.</p>
          </div>
          <div className="value-card">
            <h3>Prevention</h3>
            <p>Providing early detection to minimize long-term risks.</p>
          </div>
        </div>
      </motion.div>

      {/* ✅ Meet the Team Section */}
      <motion.div
        className="about-team"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <h2 className="section-title">Meet the Founders</h2>
        <div className="team-grid">
          {/* ✅ Founder - Justin B. Bordner */}
          <div className="team-card">
            <h3>Justin B. Bordner</h3>
            <p className="team-role">Founder</p>
            <p className="team-bio">
              As a former athlete, Justin B. Bordner has firsthand experience with head injuries and understands the risks 
              associated with long-term brain trauma. His background in software development and business strategy has driven 
              him to create AI-powered solutions that ensure immediate concussion detection and better player safety.
            </p>
          </div>

          {/* ✅ Co-Founder - Matthew R. Barraco */}
          <div className="team-card">
            <h3>Matthew R. Barraco</h3>
            <p className="team-role">Founder</p>
            <p className="team-bio">
              With expertise in biotechnology and a background in competitive sports, Matthew Barraco combines scientific 
              research with real-world applications. His focus on AI-driven medical technology helps ChronicTrace bridge 
              the gap between innovation and practical concussion management.
            </p>
          </div>

          {/* ✅ Co-Founder - Bryce M. Walker */}
          <div className="team-card">
            <h3>Bryce M. Walker</h3>
            <p className="team-role">Head of Strategic Operations & Co-Founder</p>
            <p className="team-bio">
              With a sharp acumen for strategy and operations, Bryce M. Walker has played a pivotal role in guiding ChronicTrace’s vision 
              into executable milestones. His leadership ensures seamless collaboration across research, development, and outreach, 
              driving the platform toward scalable success.
            </p>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default About;